import { Button } from '@eliadmin/core/src/components/ui/button';
import {
  ResponsiveDialog,
  ResponsiveDialogContent,
  ResponsiveDialogTrigger,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useState } from 'react';
import { IoFunnelOutline } from 'react-icons/io5';
import { CurriculumsFilterContent } from './curriculums-filter-content';

export const CurriculumsFilterButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ResponsiveDialog open={isOpen} onOpenChange={setIsOpen}>
      <ResponsiveDialogTrigger asChild>
        <Button className="w-full gap-4">
          <IoFunnelOutline className="h-5 w-5" />
          Filter
        </Button>
      </ResponsiveDialogTrigger>
      <ResponsiveDialogContent>
        <div className="flex max-h-[90vh] flex-col gap-6 overflow-y-scroll px-3 py-2 pb-10">
          <CurriculumsFilterContent />
        </div>
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
